import Auth from '~models/auth'
import api from '~utils/http'

class AuthRepositoryImpl {
  async guestLogin(params: Auth.ILogInGuest) {
    return (
      await api.post<Auth.LogInGuest.Response>(
        `/app/account/signin/anonymous/`,
        new Auth.LogInGuest(params)
      )
    ).data
  }

  async socialLogin(params: Auth.ISocialLogin) {
    return (
      await api.post<Auth.LogIn.Response>(
        `/app/account/signin/${params.platform}/`,
        new Auth.SocialLogin(params).toDto()
      )
    ).data
  }

  async sendOtpToPhoneNumber(params: Auth.SendOtpToPhoneNumber) {
    return (await api.post<{ token: string }>(`/app/account/send_phone_verification/`, params)).data
  }
}

const AuthRepository = new AuthRepositoryImpl()
export default AuthRepository
